(() => {
  'use strict';
  if (window.cx7Listicle) return;
  window.cx7Listicle = true;
  const page = document;
  if (!page.querySelector('.cx7-page #lgl-hero')) throw new Error('CX7: Required LIS7 hero missing. Check template sections.');
  const incoming = new URLSearchParams(window.location.search);
  page.querySelectorAll('[data-lgl-cta]').forEach(link => {
    const url = new URL(link.href);
    // Existing CTA values win; append only the first value of a new key.
    for (const [key, value] of incoming) {
      if (!url.searchParams.has(key)) url.searchParams.append(key, value);
    }
    link.href = url.href;
  });

  // LIS7 media: every slot starts with its still (<name>-still.webp, small, lazy below the hero).
  // The animated loop (data-lgl-anim) is fetched only when the slot comes near the viewport
  // (hero: after the page has loaded) and swapped in once decoded. Reduced motion and Data Saver keep the still.
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const motionOK = !saveData && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const animate = img => {
    if (img.dataset.lglAnimState) return;
    img.dataset.lglAnimState = 'loading';
    const loop = new Image();
    loop.onload = () => { img.src = img.dataset.lglAnim; img.dataset.lglAnimState = 'playing'; };
    loop.onerror = event => {
      img.dataset.lglAnimState = 'failed';
      img.removeAttribute('src');
      const message = document.createElement('p');
      message.setAttribute('role', 'alert');
      message.textContent = 'CX7: Animation konnte nicht geladen werden. Bitte Seite neu laden und Theme-Datei prüfen.';
      img.after(message);
      throw new Error('CX7: Required animation failed: ' + img.dataset.lglAnim, { cause: event });
    };
    loop.src = img.dataset.lglAnim;
  };
  if (motionOK) {
    const loops = Array.from(page.querySelectorAll('img[data-lgl-anim]'));
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { observer.unobserve(entry.target); animate(entry.target); }
      }), { rootMargin: '200px 0px' });
    const start = () => loops.forEach(img => {
      if (img.closest('#lgl-hero')) animate(img);
      else observer.observe(img);
    });
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  }

  const sticky = page.querySelector('.lgl-sticky');
  if (!sticky) return; // LIS7: Kaufleiste bewusst entfernt (24.10.2026)
  const mobile = window.matchMedia('(max-width: 915px)');
  const rendered = element => element.getClientRects().length > 0;
  let stickyHeight = 96;
  let queued = false;
  function updateSticky() {
    queued = false;
    // Authorized missing-section behavior: start at the next rendered reason
    // numbered >= 3. If none remain, do not enable the sticky.
    const start = Array.from(page.querySelectorAll('[data-lgl-reason]'))
      .find(element => Number(element.dataset.lglReason) >= 3 && rendered(element));
    const offerButtons = page.querySelectorAll('#lgl-grund-8 [data-lgl-cta], #lgl-faq [data-lgl-cta]');
    const offerVisible = Array.from(offerButtons).some(element => {
      if (!rendered(element)) return false;
      const rect = element.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    });
    // LIS7: never cover an in-page button; hide while any button reaches the bar's area.
    const barTop = window.innerHeight - stickyHeight;
    const covers = Array.from(page.querySelectorAll('.lgl-button')).some(button => {
      if (sticky.contains(button) || !rendered(button)) return false;
      const rect = button.getBoundingClientRect();
      return rect.bottom > barTop && rect.top < window.innerHeight;
    });
    sticky.hidden = !mobile.matches || !start || start.getBoundingClientRect().top > window.innerHeight * 0.7 || offerVisible || covers;
    if (!sticky.hidden) stickyHeight = sticky.getBoundingClientRect().height + 8;
  }
  function scheduleUpdate() {
    if (!queued) {
      queued = true;
      requestAnimationFrame(updateSticky);
    }
  }
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  mobile.addEventListener('change', scheduleUpdate);
  document.querySelectorAll('.cx7-page').forEach(section => new ResizeObserver(scheduleUpdate).observe(section));
  updateSticky();
})();
